import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';

@Component({
    selector: 'app-sub-lob-decom-assignment',
    templateUrl: './sub-lob-decom-assignment.component.html',
    styleUrl: './sub-lob-decom-assignment.component.css',
    standalone: false
})
export class SubLobDecomAssignmentComponent {

  @Input() subLobDetails: any;
  @Output() closePopUp: EventEmitter<any> = new EventEmitter<any>();
  @Input() reloadData: any;

  dropdownValues: any[] = [];
  decomLobName: string = '';
  SubLobID: string;
  searchTxt: string = ''; // Initialize searchTxt
  subLobName: string = '';
  disableEditDecomLob: boolean = true;
  decomLobID: any;
  filteredOptions: Observable<string[]>;
  decomLobNameControl = new FormControl();

  constructor( private maintenanceService: MaintenanceService,
    public toaster: ToastrService,
  ) {}

  ngOnInit() {
    this.resetFields();
    if(this.dropdownValues.length == 0) {
      this.loadDecomLobValues();
    }
  }

  ngOnChanges() {
    this.resetFields();
    if(this.subLobDetails) {
      this.SubLobID = this.subLobDetails.SubLobID;
      this.subLobName = this.subLobDetails.SubLineofBusiness;
      this.decomLobID = this.subLobDetails.DecomLobID;
      this.decomLobName = this.subLobDetails.DecomLobName;
    }
  }

  resetFields() {
    this.subLobName = '';
    this.decomLobName = '';
    this.decomLobID = null;
    this.SubLobID = null;
    this.searchTxt = ''; // Reset searchTxt
    this.disableEditDecomLob = true;
  }
  
  loadDecomLobValues() {
    this.maintenanceService.getDecomLobMasterMapping().subscribe((data) => {
      if(data) {
        this.dropdownValues = data;
      }
    }, (error) => {
      console.error(error);
    });
  }

  onSelectionChange(event) {
    this.decomLobID = this.dropdownValues.find(item => item.name === event.value)?.DecomLobID;
    this.checkIfChanged();
  }

  checkIfChanged() {
    if(this.decomLobID != this.subLobDetails.DecomLobID) {
      this.disableEditDecomLob = false;
    } else {
      this.disableEditDecomLob = true;
    }
  }

  updateDecomLob() {
    const payload = {
      decomLobID: this.decomLobID
    };
    this.maintenanceService.updateDecomLob(this.SubLobID, payload).subscribe((res) => {
      if(res.status == 'Success') {
        this.toaster.success('Successfully updated details', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      }
      this.closePopUp.emit();
    }, (error) => {
      console.error(error);
      this.toaster.error(`Something went wrong`, '', { timeOut: 5000, positionClass: 'toast-top-center' });
    });
  }
}
